import truncate from 'lodash/truncate';

import * as R from 'ramda';
import React from 'react';
import PropTypes from 'prop-types';

import withFullScreen from 'components/FullScreenable';
import { CATEGORICAL_SUMMARY_COLUMNS } from '../../../components/NumericalSummary/columns';

const CategoricalSummaryComponent = ({ summary, ...props }) => (
  <div
    className="content-item-auto mb-15"
    ref={props.captureContentItemElement}
  >
    <div className="flex flex-shrink space-between">
      <p className="font-700 mb-5">
        Summary Table
      </p>

      <div>
        <button
          type="button"
          onClick={props.onFullScreenIconClick}
          className="icon icon-fullscreen cursor-pointer font-14 in-blue-500 ml-15"
        />
      </div>
    </div>

    <div className="mb-15">
      <span className="main-checkbox-filter__props bg-grey-200 mr-5">
        <i className="icon icon-a-z" />
      </span>

      <span className="align-middle font-14">
        Categorical Variables
      </span>
    </div>

    <table className="main-table">
      <colgroup>
        <col className="bg-grey-150" />
      </colgroup>

      <thead>
        <tr>
          <th>
            Variables
          </th>

          {R.keys(props.selectedColumns).filter(columnName => CATEGORICAL_SUMMARY_COLUMNS[columnName]).map(name => {
            return (
              <th key={name} className="text-right" >
                {CATEGORICAL_SUMMARY_COLUMNS[name]}
              </th>
            );
          })}
        </tr>
      </thead>

      <tbody>
        {
          R.flatten(
            R.keys(summary).map(property => (
              R.keys(summary[property].levels).map((level, index) => {
                const levelsCount = R.keys(summary[property].levels).length;
                return (
                  <tr key={`${property}-${level}`}>
                    {index === 0 &&
                      <td rowSpan={levelsCount} className="font-13 font-700">
                        {truncate(property, { length: 20 })}
                        {' '}
                        -
                        {' '}
                        {levelsCount}
                        {' '}
                        Levels Listed
                      </td>
                    }
                    {Object.keys(props.selectedColumns).includes('levels') &&
                    <td>
                      {level}
                    </td>
                    }
                    {Object.keys(props.selectedColumns).includes('proportions') &&
                    <td className="text-right">
                      {parseFloat(summary[property].levels[level].proportion.toFixed(4))}
                    </td>
                    }
                    {Object.keys(props.selectedColumns).includes('numberOfObservations') &&
                    <td
                      className="text-right"
                    >
                      {summary[property].levels[level].count}
                    </td>
                    }
                    {index === 0 && Object.keys(props.selectedColumns).includes('totalNumberOfObservations') &&
                      <td rowSpan={R.keys(summary[property].levels).length} className="text-right">
                        {summary[property].count}
                      </td>
                    }
                  </tr>
                );
              })
            ))
          )
        }
      </tbody>
    </table>
  </div>
);

CategoricalSummaryComponent.propTypes = {
  summary: PropTypes.object.isRequired,
  selectedColumns: PropTypes.object,
  onFullScreenIconClick: PropTypes.func.isRequired,
  captureContentItemElement: PropTypes.func.isRequired
};

export default withFullScreen(CategoricalSummaryComponent);
